var $1af2d8da2ac01e1f$exports = {};
$1af2d8da2ac01e1f$exports = {
    "(optional)": `(\u{C120}\u{D0DD} \u{C0AC}\u{D56D})`,
    "(required)": `(\u{D544}\u{C218} \u{C0AC}\u{D56D})`
};


export {$1af2d8da2ac01e1f$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
